import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import sanitize from 'sanitize-html';
import { LabelSmall } from '@styled';
import useClickOutside from '@hooks/useClickOutside';

const Dropdown = ({
    disabled,
    dropdownClasses,
    dropdownMenuLinkClasses,
    dropdownMenuClasses,
    dropdownItemClasses,
    options = [],
    selectedOption = null,
    onOptionSelect,
}) => {
    // -----------------------------
    // State
    // -----------------------------

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const clickOutsideRef = useRef(null);

    // -----------------------------
    // Render
    // -----------------------------

    useClickOutside({ ref: clickOutsideRef, onClickOutside: () => setDropdownOpen(false) });

    const rappaClasses = classnames('dropdown-rappa', { show: dropdownOpen });
    const selection = selectedOption || options[0] || { id: null, selectedLabel: '' };

    return (
        <div className={dropdownClasses}>
            <div className={rappaClasses} ref={clickOutsideRef}>
                {/* eslint-disable-next-line */}
                <button
                    id="dropdownMenuLink"
                    type="button"
                    href="#"
                    className={dropdownMenuLinkClasses}
                    aria-haspopup="true"
                    aria-expanded={dropdownOpen}
                    style={styles.menuToggleLink}
                    onClick={event => {
                        event.preventDefault();
                        if (disabled) {
                            return;
                        }

                        setDropdownOpen(!dropdownOpen);
                    }}
                >
                    <span className="font-sans text-secondary">{selection.selectedLabel}</span>
                </button>

                <div className={dropdownMenuClasses} id="dropdownMenu" aria-labelledby="dropdownMenuLink">
                    {options.map(option => {
                        const optionClasses = classnames(
                            dropdownItemClasses,
                            { accent: option.id === selection.id },
                            { disabled: option.disabled }
                        );

                        const optionStyles = {
                            ...styles.dropdownOption,
                            display: option.hidden ? 'none' : 'inherit',
                        };

                        /* eslint-disable */
                        return (
                            <button
                                key={option.id}
                                type="button"
                                className={optionClasses}
                                style={optionStyles}
                                dangerouslySetInnerHTML={{ __html: sanitize(option.optionLabel) }}
                                onClick={() => {
                                    setDropdownOpen(false);
                                    onOptionSelect(option);
                                }}
                            />
                        );
                        /* eslint-enable */
                    })}
                </div>
            </div>
        </div>
    );
};

const styles = {
    menuToggleLink: {
        background: 'none',
        border: 'none',
        fontFamily: 'Red Hat Display',
        outline: 'none',
    },
    dropdownOption: {
        border: 'none',
        fontFamily: 'Red Hat Display',
        outline: 'none',
    },
};

Dropdown.propTypes = {
    disabled: PropTypes.bool,
    dropdownClasses: PropTypes.string,
    dropdownMenuLinkClasses: PropTypes.string,
    dropdownMenuClasses: PropTypes.string,
    dropdownItemClasses: PropTypes.string,
    options: PropTypes.array.isRequired,
    selectedOption: PropTypes.object,
    onOptionSelect: PropTypes.func,
};

export default Dropdown;
